import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  root: {
    width: '100%',
    padding: '0 0 0.5rem',
    overflowY: 'auto',
    flex: 1,
    minHeight: 0,
  },
  tabSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '16px',
    marginBottom: '16px',
  },
  saveButton: {
    flexShrink: 0,
    alignSelf: 'flex-start',
  },
  brandingContent: {
    width: '100%',
    minWidth: '600px',
    paddingBottom: '4rem',
    textAlign: 'left',
  },
  colorsPreviewRow: {
    marginTop: '40px',
    display: 'flex',
    alignItems: 'flex-start',
  },
  progressTrackerSection: {
    width: '100%',
    minWidth: '600px',
    paddingLeft: '24px',
    paddingBottom: '4rem',
    textAlign: 'left',
    marginTop: '16px',
  },
});
